import { guideKind, guideOpenUrl } from '../../services/guides'
import './guides.css'

const KIND_LABEL = { url: 'LINK', image: 'IMG', video: 'VID', pdf: 'PDF', file: 'FILE' }

// Render attached guides as clickable chips. `onRemove(guide)` (optional) shows a
// remove button (used in composers); omit it for read-only display.
export function GuideChips({ guides, onRemove }) {
  // Deleted guides come back as null from populate; drop them.
  const list = (guides || []).filter(Boolean)
  if (!list.length) return null
  return (
    <div className="guide-chips">
      {list.map((guide) => {
        const kind = guideKind(guide)
        const label = guide.title || guide.name || 'Guide'
        return (
          <span key={guide._id} className="guide-chip">
            <a
              className="guide-chip-link"
              href={guideOpenUrl(guide)}
              target="_blank"
              rel="noopener noreferrer"
              title={label}
            >
              <span className="guide-chip-kind">{KIND_LABEL[kind] || 'FILE'}</span>
              <span className="guide-chip-title">{label}</span>
            </a>
            {onRemove ? (
              <button
                type="button"
                className="guide-chip-x"
                title="Remove guide"
                aria-label={`Remove ${label}`}
                onClick={() => onRemove(guide)}
              >
                ×
              </button>
            ) : null}
          </span>
        )
      })}
    </div>
  )
}

export default GuideChips
